import almoxarifado from './almoxarifado'
import usuario from './usuario'
import laboratorio from './laboratorio'

export default [
    {
        path: 'web-service',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...almoxarifado,
            ...usuario,
            ...laboratorio,
        ],
    },
]